/*

--------------------------------------------------------------------------------
Eshop iframe functions
--------------------------------------------------------------------------------

<![CDATA[

*/

( function( $ ) {

    'use strict';

    if( typeof ori != "object" || typeof ori.messenger != "object" ) return;

    var self = ori.messenger,
        E_CATLOGUE_DETAIL_WINDOW = 'e-catalogue-detail-window',
        E_CATLOGUE_DETAIL_WINDOW_ID = '#' + E_CATLOGUE_DETAIL_WINDOW,
        LOYALTY_POINTS_WINDOW = 'loyalty-points-window',
        LOYALTY_POINTS_WINDOW_ID = '#' + LOYALTY_POINTS_WINDOW,
        ORDER_DETAIL_IFRAME = 'orderDetailIframe',
        QUICK_BUY_WINDOW = 'quick-buy-window',
        QUICK_BUY_WINDOW_ID = '#' + QUICK_BUY_WINDOW,
        KENDO_WINDOW_PADDING_H = 70,
        KENDO_WINDOW_PADDING_V = 60;

    ori.messenger = $.extend(true , ori.messenger , {

        // default additional options
        options: {
            pendingOrdersId: "pendingIframe",
            contentOrdersId: "contentIframe"
        },

        // map of additional message actions
        actionsMap: {
            "aanhelp": "showAanHelp",
            "eshopAddToBasket": "eshopAddToBasket",
            "eshopRemoveFromBasket": "eshopRemoveFromBasket",
            "novaToolbarRefreshLoyaltyPoints": "eshopStickyBarRefreshLoyaltyPoints",
            "novaToolbarClearBasketTotals": "eshopStickyBarClearBasketTotals",
            "eshopClearBasket": "eshopClearBasket",
            "eshopProductDetail": "eshopProductDetail",
            "eshopLoyaltyProductDetail": "eshopLoyaltyProductDetail",
            "bvTrack": "eshopBvTrack",
            "eCatDetail": "eshopOrderDetail",
            "eCatOrderDelete": "closeOrderWindow",
            "eCatOrderAdd": "closeOrderWindow"
        },

        addBeautyRewardsProductUrl: "/system/ajax/Basket/AddBeautyRewardsProductToBasket",
        removeBeautyRewardsProductUrl: "/system/ajax/Basket/RemoveBeautyRewardsProductFromBasket",
        clearBasketUrl: "/system/ajax/Basket/ClearBasket",

        loadEshopIframe: function (iframeId, settings) {
            if (settings && settings.requiresAuthentication) {
                ori.webApi.initializeCommunication(function() {
                    self.loadIframe(iframeId, settings);
                }, function() {
                    self.errorIframeLoadCallback($("#" + iframeId), settings);
                });
                return;
            }
            self.loadIframe(iframeId, settings);
        },

        getProduct: function (url, callback) {
            $.ajax({
                dataType: 'json',
                url: url,
                success: function (data) {
                    if (typeof callback === 'function') {
                        callback(data);
                    }
                },
                cache: false
            });
        },

        /**
         * Product detail from eshop
         */
        eshopProductDetail: function (msg) {
            var template = kendo.template($('#kendo-template-quick-shop').html(), { useWithBlock : false }),
                str = msg.split("strJSON="),
                json = JSON.parse(str[str.length -1]),
                dataUrl = '/system/ajax/Product/DetailJson?code=' + json["skuName"];

            self.getProduct(dataUrl, function (response) {
                if (!response.Product) return;

                if (ori.quickShop) ori.quickShop.updateProductResponse(response.Product);

                var data = {
                    context: $(template(response.Product)),
                    numericTextBox: {
                        min: response.Product.MinQuantityOfProduct,
                        max: response.Product.MaxQuantityOfProduct,
                        value: response.Product.Quantity
                    },
                    addToBagWhenOutOfStockAllowed: response.ShowAddToBagInOutOfStock
                };

                $('body').append(
                    $('<div />')
                        .attr('id', QUICK_BUY_WINDOW)
                        .html(data.context)
                );

                $(QUICK_BUY_WINDOW_ID).kendoWindow({
                    visible: false,
                    title: false,
                    setOverlay: true,
                    resizable: false,
                    draggable: false,
                    deactivate: function () {
                        this.destroy();
                    },
                    activate: function () {
                        if (ori.product) ori.product.init(data);
                        if (ori.cutShort) ori.cutShort.init(data);
                        if (ori.quickShop) ori.quickShop.applyBpTooltip();
                    }
                }).data('kendoWindow').open();
            });

        },

        /**
         * Order detail from eshop
         */
        eshopOrderDetail: function (msg) {
            var orderId = self.getMessageParam(msg, 'CWOrder'),
                contentId = ($('#' + self.options.contentOrdersId).length > 0) ? self.options.contentOrdersId : self.options.pendingOrdersId,
                srcArr = $('#' + contentId).attr('src').split('?'),
                srcBase = srcArr[0].substring(0, srcArr[0].lastIndexOf('/')) + '/ECatOrder.aspx?',
                iframeSrc = srcBase + srcArr[1] + '&CWOrder=' + orderId;

	        iframeSrc = iframeSrc.replace(self.options.pendingOrdersId, 'orderDetailIframe');

	        if (typeof ori.popup !== 'object' || !orderId) return;

            var $eCatDetailWindow = ori.popup.preparePopupWindow(E_CATLOGUE_DETAIL_WINDOW).addClass('k-window-no-overflow'),
                kendoECatDetailWindow;

	        $eCatDetailWindow.kendoWindow({
	            iframe: true,
	            content: iframeSrc,
	            visible: false,
	            setOverlay: true,
	            width: 880 + KENDO_WINDOW_PADDING_H,
	            height: 510 + KENDO_WINDOW_PADDING_V,
	            title: false,
	            resizable: false,
	            draggable: false,
	            open: function () {
	                ori.spinner && ori.spinner.applyOverlayTo(E_CATLOGUE_DETAIL_WINDOW_ID);
	            },
	            refresh: function () {
	                ori.spinner && ori.spinner.removeOverlayFrom(E_CATLOGUE_DETAIL_WINDOW_ID);
	            },
	            close: function () {
	                self.transceiver(contentId, '{"action" : "reload", "iframeId" : "' + contentId + '"}');
	                setTimeout(function() {
	                    ori.spinner.applyOverlayTo('.w-iframe:first');
	                }, 200);
	                setTimeout(function() {
	                    ori.spinner.removeOverlayFrom('.w-iframe:first');
	                }, 1200);
	            },
	            deactivate: function () {
	                this.destroy();
                }
	        });
	        kendoECatDetailWindow = $eCatDetailWindow.data('kendoWindow');
	        kendoECatDetailWindow.wrapper.find('iframe').attr({
	            scrolling: 'no',
	            id: ORDER_DETAIL_IFRAME
	        });
	        kendoECatDetailWindow.open();
        },

        /**
         * Close order detail window and reload iframe with order list
         */
        closeOrderWindow: function (msg) {
            var $eCatDetailWindow = $(E_CATLOGUE_DETAIL_WINDOW_ID),
                kendowECatDetailWindow;

            if ($eCatDetailWindow.length) {
                kendowECatDetailWindow = $eCatDetailWindow.data('kendoWindow');
                kendowECatDetailWindow && kendowECatDetailWindow.close();
            }
        },

        /**
         * Loyalty product detail from eshop
         */
        eshopLoyaltyProductDetail: function (msg) {
            var template = kendo.template($('#kendo-template-loyalty-product-detail').html(), { useWithBlock: false }),
                str = msg.split("strJSON="),
                json = JSON.parse( str[str.length - 1] ),
                dataUrl = '/system/ajax/Product/DetailJson?code=' + json["skuName"];

            self.getProduct(dataUrl, function (response) {
                if (!response.Product || typeof ori.popup !== 'object') return;
                response.Product["points"] = json["points"];

                var $loyaltyPointWindow = ori.popup.preparePopupWindow(LOYALTY_POINTS_WINDOW).append($(template(response.Product)));
                $loyaltyPointWindow.kendoWindow({
                    visible: false,
                    setOverlay: true,
                    title: false,
                    resizable: false,
                    draggable: false,
                    deactivate: function () {
                        this.destroy();
                    }
                }).data('kendoWindow').open();
            });

        },

        /**
         * Shows AAN help box on request from iframe.
         */
        showAanHelp: function(msg) {
            if (!ori.lightbox) {
                this.error("Lightbox module not found.");
                return;
            }
            var page = getMessageParam(msg, "page");
            if (!page) page = 1;
            ori.lightbox.popup({
                type: "url",
                link: "/consultants/aan-help.jhtml?part=" + page,
                innerWidth: 1024,
                innerHeight: 950,
                iframe: true,
                opacity: 0.3,
                scrolling: false,
                appendClass: "aanHelp"
            });
        },

        eshopAddToBasket: function(msg) {
            var loyaltyProduct = JSON.parse(ori.messenger.getMessageParam(msg, "strJSON"));
            self.info("Adding loyalty product [" + loyaltyProduct.productCode + "] to basket...");

            jQuery.ajax({
                url: self.addBeautyRewardsProductUrl,
                type: "POST",
                dataType: "json",
                data: {
                    productCode: loyaltyProduct.productCode,
                    quantity: 1,
                    beautyPoints: loyaltyProduct.points
                },
                success: function (data) {
                    data = self.updateJsonResult( data );
                    if (data.errorMessage) {
                        self.warning("Add beauty rewards product to basket failed due to: " + data.errorMessage);
                        return;
                    }
                    self.triggerBeatyPointsChanged(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    self.error("Error adding beauty rewards product: " + errorThrown);
                }
            });
        },

        eshopRemoveFromBasket: function(msg) {
            var loyaltyProduct = JSON.parse(ori.messenger.getMessageParam(msg, "strJSON"));
            self.info("Removing loyalty product [" + loyaltyProduct.productCode + "] from basket...");

            jQuery.ajax({
                url: self.removeBeautyRewardsProductUrl,
                type: "POST",
                dataType: "json",
                data: { productCode: loyaltyProduct.productCode },
                success: function(data) {
                    data = self.updateJsonResult( data );
                    if (data.errorMessage) {
                        self.warning("Remove beauty rewards product from basket failed due to: " + data.errorMessage);
                        return;
                    }
                    self.triggerBeatyPointsChanged( data );
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    self.error("Error adding beauty rewards product: " + errorThrown);
                }
            });
        },

        eshopStickyBarRefreshLoyaltyPoints: function (msg) {
            var points = ori.messenger.getMessageParam(msg, "points");

            ori.stickyBar?.refreshBeautyPoints(points);
        },

        eshopStickyBarClearBasketTotals: function (msg) {
            ori.stickyBar?.removeBasketInfoBubble();
        },

        eshopClearBasket: function(msg) {
            var isPreorder = ori.messenger.getMessageParam(msg, "isPreorder");
            var lastWarehouse = ori.messenger.getMessageParam(msg, "lastWarehouse");
            self.info("Clearing basket...");

            jQuery.ajax({
                url: self.clearBasketUrl,
                type: "POST",
                dataType: "json",
                data: {
                    isPreorder: isPreorder,
                    lastWarehouse: lastWarehouse
                },
                success : function( data ) {
                    if( ! data || ! data.message ) {
                        self.error( "Error clearing basket." );
                        return;
                    }
                    if( data.message != "Ok" ) {
                        self.error( "Error clearing basket : %s", data.message );
                        return;
                    }
                    self.info( "Basket cleared successfully." );
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    self.error("Error clearing basket: " + errorThrown);
                }
            });
        },

        /**
         * Used for tracking order confirmation data via Bazaarvoice.
         */
        eshopBvTrack : function( msg ) {
            if( ! ori.analytics ) {
                self.warning( "Analytics module not found, can't use Bazaarvoice tracking." );
                return;
            }
            var bvData = self.getMessageParam( msg, "strJSON" );
            self.info( "Calling Bazaarvioce tracking ..." );
            ori.analytics.bvTrackTransactionPageView( bvData );
        },

        triggerBeatyPointsChanged: function (data) {
            var event = $.Event("remainngBeautyPointsCountChanged", data);
            self.trigger(event);
        }
    });

    ori.messenger.info("E-shop iframe methods successfully appended.");

} )( jQuery );

/* ]]> */
